<template>
  <div id="share-modal" tabindex="-1" role="dialog" class="modal fade modal-colored-header" style="display: none;">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Liberar para o app?</h4>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <loader :show-loader="loading"></loader>
          <div v-show="!loading" class="row">

            <div class="col-md-12 d-flex justify-center pb-2em">
              <p>
                <a class="app-link" target="_blank" href="https://play.google.com/store/apps/details?id=org.nativescript.upsell">
                  Clique aqui
                </a>
                para baixar o UPsell no seu celular (disponível no Google Play)
              </p>
            </div>

            <div v-if="canAllowPostersToApp" class="col-md-12 d-flex justify-center pb-2em">
              <div class="am-checkbox agroup">
                <input type="checkbox" id="agroup" v-model="agroup">
                <label for="agroup">
                  Agrupar?
                </label>
                <i
                        class="fa fa-info-circle info-icon original-position"
                        data-html="true"
                        data-trigger="hover"
                        data-toggle="popover"
                        data-placement="bottom"
                        data-content="Agrupa as ofertas selecionadas para serem visualizadas em uma pasta no App.">
                </i>
              </div>

              <v-select
                      v-if="agroup"
                      class="w-50"
                      data-toggle="popover"
                      data-trigger="hover"
                      data-placement="top"
                      data-content="Digite um nome de identificação para visualizar no app"
                      taggable
                      v-model="selectedGroup"
                      :options="groupsList">
                <span slot="no-options">Digite para criar um novo grupo.</span>
              </v-select>
            </div>

          </div>
          <img alt="" id="result-image">
        </div>

        <div class="modal-footer">
          <buttton data-dismiss="modal" class="btn btn-outline-secondary">Não</buttton>

          <button @click="allowToApp()" class="btn btn-secondary text-white">
            Sim
          </button>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
  import vSelect from 'vue-select';

  export default {
    name: 'share-posters-modal',

    components: {
      vSelect,
    },

    props: {
      subDomain: String,
      inHomologation: Boolean,
      canAllowToApp: Boolean,
      whatsUrl: String,
      downloadUrl: String,
      instagramUrl: String,
      facebookUrl: String,
      allowToAppUrl: String,
      createAppGroupUrl: String,
      appGroups: Array,

    },

    mounted() {
      this.$root.$on('show-share-modal', (posters) => {
        this.posters = posters;
        $('#share-modal').modal('show');
        this.loadPosters();
      });
    },

    computed: {
      canAllowPostersToApp() {
        return this.canAllowToApp || (this.isMagazine);
      },

      isMagazine() {
        return this.subDomain === 'magazineluiza';
      },

      instagramPopover() {
        return 'Caso compartilhe mais de um cartaz, será enviado como um álbum. '
          + 'Um álbum pode conter no máximo 10 imagens.';
      },

      selectedPosters() {
        return this.postersContent.filter((poster) => poster.share);
      },
    },

    data() {
      return {
        csrf: $('meta[name="csrf-token"]').attr('content'),

        posters: [],
        loading: false,
        sharing: false,
        showInstagramForm: false,
        postersContent: [],
        captionText: '',
        username: undefined,
        password: undefined,
        facebookAuth: undefined,
        selectedGroup: undefined,
        groupsList: this.appGroups,
        agroup: false,
      };
    },

    watch: {
      agroup: _.debounce(function (value) {
        if (value)
          $("[data-toggle='popover']").popover();
      }, 50),

      postersContent(posters) {
        if (posters.length > 0) {
          this.$nextTick().then(() => {
            this.scaleImages();

            this.$root.$emit('get-posters-content', posters);
          });
        }
      },

      showInstagramForm(showInstagramForm) {
        if (!showInstagramForm) {
          this.username = undefined;
          this.password = undefined;
        }
      },
    },

    methods: {
      getBase64RealData(poster) {
        let block = poster.base64.split(';');
        let contentType = block[0].split(':')[1];
        return block[1].split(',')[1];
      },

      allowToApp() {
        if (this.selectedPosters.length == 0) {
          return this.$root.throwFlashMessage('danger', 'Por favor, selecione ao menos um cartaz para liberação.');
        }

        if (this.agroup && !this.selectedGroup) {
          return this.$root.throwFlashMessage('danger', 'Por favor, selecione o grupo da liberação.');
        }
        this.loading = true;
        this.sharing = true;

        (!!this.selectedGroup && !this.selectedGroup.value)
          ? this.createNewGroup().then(() => this.syncPosters())
          : this.syncPosters();
      },

      syncPosters() {
        let vm = this;
        let payload = {
          group: vm.selectedGroup,
          posters: this.selectedPosters.map((poster) => poster.id),
        };

        axios.post(vm.allowToAppUrl, payload)
          .then((response) => {
            $('#share-modal').modal('hide');
            this.throwPopUp(response.data.message, 30);
          }).catch((error) => {
          vm.$root.throwFlashMessage('danger', 'Houve um problema ao liberar os cartazes.');
        }).finally(() => vm.stopLoading());
      },

      createNewGroup() {
        if (typeof this.selectedGroup == 'string') {
          const name = this.selectedGroup;
          this.selectedGroup = {
            label: name
          };
        }
        return axios.post(this.createAppGroupUrl, {
          name: this.selectedGroup.label
        }).then((response) => {
          const id = response.data.id;

          const newGroup = {
            value: id,
            label: this.selectedGroup.label,
          };

          this.groupsList.push(newGroup);

          this.selectedGroup = newGroup;
        });
      },

      stopLoading: _.debounce(function () {
        this.loading = false;
        this.sharing = false;
      }, 100),

      scaleImages: _.debounce(function () {
        this.postersContent.map((poster) => this.setScale(`poster-${poster.id}`, poster));
      }, 2000),

      loadPosters() {
        this.loading = true;
        this.postersContent = [];

        let payload = {posters: this.posters};

        axios.post('/ajax/posters/content', payload).then((response) => {
          (response.data.message)
            ? this.$root.throwFlashMessage('danger', response.data.message)
            : this.postersContent = response.data.data;
        }).catch((error) => {
          this.$root.throwFlashMessage('danger', 'Houve um problema ao carregar os cartazes');
        }).finally(() => this.loading = false);

      },

      setScale(element, poster) {
        const $image = $(`#${element}`).find('img[data-role=backgroundImage]');
        let closest = $image.closest('.poster-div');
        this.setZoom(closest, element, $image, poster);
      },

      setZoom(closest, posterPreview, image, poster) {
        const imgWidth = image.width();
        const imgHeight = image.height();
        let scale;
        let origin;
        if (imgWidth > imgHeight) {
          const divWidth = closest.width();
          scale = divWidth / imgWidth;
          origin = '0 0';
        } else {
          const divHeight = closest.height();
          scale = divHeight / imgHeight;
          origin = '0 0';
        }

        const preview = $(`#${posterPreview}`);
        preview.css('width', imgWidth).css('height', imgHeight);

        preview.css('transform', 'scale(' + scale + ')').css('transform-origin', origin);
        image.css('outline', '1px solid #323232');

        closest.css('overflow', 'visible')
      },

      posterToBase64(posterPreview, poster) {
        let selector = document.getElementById(posterPreview);
        return this.toBase64(selector, poster);
      },

      toBase64(selector, poster) {
        return html2canvas(selector, {
          logging: false,
          allowTaint: true,
          removeContainer: false,
        }).then((canvas) => {
          poster.base64 = canvas.toDataURL('image/png');
        });
      },

      /**
       * Convert a base64 string in a Blob according to the data and contentType.
       *
       * @param b64Data {String} Pure base64 string without contentType
       * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
       * @param sliceSize {Int} SliceSize to process the byteCharacters
       * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
       * @return Blob
       */
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          let slice = byteCharacters.slice(offset, offset + sliceSize);

          let byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          let byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: contentType});
      },

      throwPopUp(message, delay = 10) {
        this.$root.$emit('show-vueup', {
          message: message,
          color: 'white',
          backgroundColor: 'rgba(30, 30, 30, 0.5)',
          delay: delay,
        });
      },
    },
  };
</script>

<style scoped>
  .poster-div {
    height: 200px !important;
    overflow: hidden;
    align-items: center;
    padding: 0 !important;
  }

  .poster-checkbox-div {
    height: 200px !important;
    display: flex;
    align-items: center;
  }

  @media (min-width: 768px) {
    .poster-checkbox {
      margin: 0;
    }
  }

  .poster-checkbox {
    margin: auto;
  }

  .text-white {
    color: #ffffff;
  }

  .btn-social {
    cursor: pointer;
  }

  .btn-whatsapp {
    background-color: #25d366;
  }

  .btn-instagram {
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
  }

  .btn-instagram:hover {
    color: #ffffff;
    background: #f09433;
    background: -moz-linear-gradient(45deg, #ff9e33 0%, #ff7442 25%, #ff2c4b 50%, #ff2c82 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #ff9d36 0%, #ff7443 25%, #ff2d4d 50%, #ff2b81 75%, #bc1888 100%);
    background: linear-gradient(45deg, #ff9b35 0%, #ff7343 25%, #ff2e4e 50%, #ff2b81 75%, #bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f09433', endColorstr='#bc1888', GradientType=1);
  }

  .btn-whatsapp:hover {
    background-color: #2cff7b;
  }

  .fa-1-5x {
    font-size: 1.5em;
  }

  .w-auto {
    width: auto !important;
    padding: 0 !important;
  }

  .w-50 {
    width: 50% !important;
  }

  @media screen and (max-width: 768px ) {
    .w-50 {
      width: 100% !important;
    }
  }

  .modal-content {
    overflow: visible;
  }

  .canvas-container {
    position: fixed;
    left: 30000px;
    overflow: visible;
  }

  .border-6 {
    border-radius: 6.79px !important;
  }

  .btn-app-group {
    color: #fff;
    background-color: #ffbe57;
    border-color: #ffbe57;
  }

  .input-group-addon {
    font-size: unset;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }


  .btn-info {
    background-color: #5d82d1;
    border-color: #2e6da4;
  }

  .btn-info:hover, .btn-info:focus {
    background-color: #286090;
    border-color: #204d74;
  }

  .pb-2em {
    padding-bottom: 2em;
  }

  .agroup {
    width: 100%;
    text-align: center;
  }

  .app-link {
    color: #c61e56;
  }

  .app-link:hover {
    color: #c61e56;
    text-decoration: underline;
  }
</style>

<style>
  .input-app-group .dropdown-toggle {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SharePostersModal.vue